(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arv-collection-v2"]) return;
  try {
    
  const desktopFilters = window.matchMedia('(min-width: 750px)');
  const panelSelector =
    '.facets-block-wrapper--vertical:not(#filters-drawer) .facets__filters-wrapper';

  function configurePremiumFilters(root = document) {
    if (!desktopFilters.matches) return;

    const wrappers = root.matches?.(panelSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(panelSelector) || []);

    wrappers.forEach((wrapper, wrapperIndex) => {
      const panels = Array.from(
        wrapper.querySelectorAll(':scope > .facets__item > .facets__panel')
      );
      if (!panels.length) return;

      const activeIndex = panels.findIndex((panel) => {
        if (panel.querySelector('input:checked')) return true;
        return Array.from(
          panel.querySelectorAll('input[ref="minInput"], input[ref="maxInput"]')
        ).some((input) => input.value.trim() !== '');
      });
      const openIndex = activeIndex >= 0 ? activeIndex : 0;
      const groupName = `arv-collection-filter-${wrapperIndex}`;

      panels.forEach((panel, panelIndex) => {
        panel.name = groupName;
        panel.open = panelIndex === openIndex;
      });
    });
  }

  function initializePremiumFilters() {
    configurePremiumFilters();

    const observerRoot = document.documentElement;
    if (observerRoot.dataset.arvPremiumFilters === 'true') return;

    observerRoot.dataset.arvPremiumFilters = 'true';
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            desktopFilters.matches &&
            (node.matches(panelSelector) || node.querySelector(panelSelector))
          ) {
            configurePremiumFilters(node);
          }
        }
      }
    });

    observer.observe(observerRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePremiumFilters, { once: true });
  } else {
    initializePremiumFilters();
  }

  document.addEventListener('shopify:section:load', initializePremiumFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
